export default __webpack_public_path__ + "assets/audios/6a455468defd570010bdf9af7e9bbba3.mp3";